import { Create } from 'react-admin'

import CourseForm from './CourseForm'
import { attachEpisodeOrder } from './CourseGroupTab'

const transform = data => ({ ...data, groups: attachEpisodeOrder(data.groups) })

const CourseCreate = props => (
  <Create redirect="list" transform={transform} {...props}>
    <CourseForm isCreating permissions={props.permissions} />
  </Create>
)

export default CourseCreate
